import Theme from '../../../theme';
import { alpha } from '@mui/material/styles';
import { MENU_DESKTOP_WIDTH, MENU_MOBILE_HEADER_HEIGHT, MENU_MOBILE_FOOTER_HEIGHT } from '../../../config';

const appMenu = ({
  desktopMenuContainer: {
    height: '100%',
  },
  mainDrawer: {
    width: MENU_DESKTOP_WIDTH,
    height: '100%',
    flexShrink: 0,
    boxSizing: 'border-box',
    backgroundColor: Theme.palette.white.main,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'relative',
    zIndex: 9,
  },
  mainDrawerHeader: {
    padding: `${Theme.spacing(4)} ${Theme.spacing(4)}`,
    textAlign: 'center',
    '& img': {
      width: '90%',
      objectFit: 'contain',
    },
  },
  quickMenuToggle: {
    width: '100%',
    marginTop: Theme.spacing(3),
    marginBottom: `${Theme.spacing(3)} !important`,
    padding: `${Theme.spacing(1)} ${Theme.spacing(2)} !important`,
    justifyContent: 'flex-start !important',
    borderRadius: '999px !important',
    border: `1px solid ${alpha(Theme.palette.black.main, 0.12)} !important`,
    color: `${Theme.palette.black.main} !important`,
    transition: 'background-color 200ms ease, border-color 200ms ease !important',
    '&:hover': {
      backgroundColor: `${Theme.palette.white.dark} !important`,
      borderColor: `${alpha(Theme.palette.primary.main, 0.3)} !important`,
    },
    '& .MuiListItemIcon-root': {
      minWidth: 32,
    },
    '& .MuiTypography-root': {
      fontSize: '12px',
      fontWeight: 700,
      letterSpacing: 1,
      textTransform: 'uppercase',
    },
    '&.active': {
      backgroundColor: `${Theme.palette.white.dark} !important`,
      borderColor: `${alpha(Theme.palette.primary.main, 0.35)} !important`,
      '& .MuiTypography-root': {
        color: Theme.palette.primary.main,
      },
    },
  },
  quickMenuList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: Theme.spacing(1),
    width: '100%',
  },
  quickMenuItem: {
    width: '100%',
    padding: `${Theme.spacing(0.75)} ${Theme.spacing(2)} !important`,
    justifyContent: 'flex-start !important',
    color: `${Theme.palette.white.main} !important`,
    textAlign: 'left',
    borderRadius: '0 !important',
    '& .MuiTypography-root': {
      fontSize: '14px',
      fontWeight: 500,
      color: 'inherit',
    },
    '&.active .MuiTypography-root': {
      fontWeight: 700,
      textDecoration: 'underline',
      textUnderlineOffset: '0.2em',
    },
  },
  mobileQuickMenu: {
    width: '100%',
    padding: Theme.spacing(0, 3, 1),
    boxSizing: 'border-box',
    flex: 1,
    minHeight: 0,
  },
  mobileQuickMenuTitle: {
    marginBottom: `${Theme.spacing(1)} !important`,
    color: `${Theme.palette.black.main} !important`,
    fontSize: '12px !important',
    fontWeight: '700 !important',
    letterSpacing: '1px !important',
  },
  mobileQuickMenuScroll: {
    maxHeight: '32vh',
    overflowY: 'auto',
    overscrollBehavior: 'contain',
    minHeight: 0,
  },
  mobileQuickMenuItem: {
    width: '100%',
    borderRadius: '999px !important',
    color: `${Theme.palette.black.main} !important`,
    justifyContent: 'flex-start !important',
    '& .MuiTypography-root': {
      color: 'inherit',
      fontSize: '13px',
      fontWeight: 500,
    },
    '&.active': {
      backgroundColor: `${alpha(Theme.palette.black.main, 0.08)} !important`,
      '& .MuiTypography-root': {
        fontWeight: 700,
        textDecoration: 'underline',
        textUnderlineOffset: '0.2em',
      },
    },
  },
  mainDrawerHeaderLink: {
    textDecoration: 'none',
    color: Theme.palette.primary.main,
    transition: 'color 0.3s ease-in-out',
    '&:hover': {
      color: Theme.palette.black.main,
    }
  },
  mainDrawerParagraph: {
    marginTop: Theme.spacing(8),
    padding: `${Theme.spacing(2)} ${Theme.spacing(0)} ${Theme.spacing(0)} ${Theme.spacing(0)}`,
    textAlign: 'left',
    color: Theme.palette.black.main,
    fontSize: '14px !important',
    lineHeight: '1.3 !important',
  },
  buttonDrawerParagraph: {
    marginTop: Theme.spacing(8),
    padding: `${Theme.spacing(4)} ${Theme.spacing(0)} ${Theme.spacing(0)} ${Theme.spacing(0)}`,
    textAlign: 'left',
    color: Theme.palette.black.main,
    fontSize: '16px !important',
    lineHeight: '1.3 !important',
  },
  gifImage:  {
    display: 'block',
    width: '100% !important',
    height: 'auto',
    border: '0.1rem solid #ededed',
  },
  gifButton: {
    position: 'relative',
    display: 'block',
    width: `calc(100%)`,
    marginTop: `${Theme.spacing(2)}`,
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'zoom-in',
    textAlign: 'left',
    appearance: 'none',
  },
  gifOverlay: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: alpha(Theme.palette.black.main, 0),
    opacity: 0,
    transition: 'opacity 200ms ease, background-color 200ms ease',
    pointerEvents: 'none',
    '$gifButton:hover &, $gifButton:focus-visible &': {
      opacity: 1,
      backgroundColor: alpha(Theme.palette.black.main, 0.2),
    },
  },
  gifOverlayIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: alpha(Theme.palette.white.main, 0.92),
    boxShadow: `0 4px 16px ${alpha(Theme.palette.black.main, 0.2)}`,
  },
  gifOverlayIcon: {
    width: 22,
    height: 22,
    objectFit: 'contain',
  },
  video:  {
    marginTop: `${Theme.spacing(2)}`,
    width: '100%',
  },
  gifDialogPaper: {
    width: 'min(100%, 1200px)',
    maxWidth: 'calc(100vw - 32px) !important',
    maxHeight: 'calc(100vh - 32px)',
  },
  gifDialogContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${Theme.spacing(5)} ${Theme.spacing(2)} ${Theme.spacing(2)} !important`,
    overflow: 'hidden',
  },
  gifDialogImage: {
    display: 'block',
    width: 'auto',
    maxWidth: '100%',
    height: 'auto',
    maxHeight: 'calc(100vh - 120px)',
    objectFit: 'contain',
  },
  gifDialogCloseButton: {
    position: 'absolute !important',
    top: Theme.spacing(1),
    right: Theme.spacing(1),
    zIndex: 1,
  },
  gifDialogCloseIcon: {
    width: 18,
    height: 18,
    objectFit: 'contain',
  },
  textRoot: {
    display: 'flex',
    flexDirection: 'column',
    gap: Theme.spacing(0),
    // paddingLeft: Theme.spacing(4),
    paddingRight: Theme.spacing(4),
  },
  Menublocklink: {
    width: 'fit-content',
    marginTop: Theme.spacing(2),
    // paddingLeft: Theme.spacing(4),
  },
  Menulabel: {
    textAlign: 'left',
    fontSize: '14px !important',
    letterSpacing: 1,
    fontWeight: '700 !important',
  },
  Menuvalue: {
    textAlign: 'left',
    fontSize: '12px !important',
    lineHeight: 1.5,
  },
  menuWebLink: {
    display: 'inline-block',
    textAlign: 'left',
    fontSize: '14px !important',
    fontWeight: '700 !important',
    letterSpacing: '1px !important',
    lineHeight: 1.5,
    marginLeft: '0 !important',
    paddingLeft: '0 !important',
    alignSelf: 'flex-start',
    color: `${Theme.palette.error.main} !important`,
    textDecoration: 'underline',
    textUnderlineOffset: '0.15em',
  },
  listItem: {
    transition: 'background-color 500ms',
    color: Theme.palette.white.main,
    '& h3::after': {
      content: '""',
      display: 'block',
      height: '1px',
      width: 0,
      position: 'absolute',
      left: 0, 
      bottom: '2px',
      transform: 'translateX(-50%)',
      transition: 'width 1000ms ease-in-out',
    },
    '&.focus': {
      '& h3': {
        position: 'relative',
        '&::after': {
          width: '50vw',
        },
      },
    },
    '& .MuiListItemButton-root': {
      paddingLeft: Theme.spacing(5),
      '& .MuiListItemIcon-root': {
        alignSelf: 'flex-start',
        marginTop: 5,
      },
    },
  },
  drawerLabel: {
    color: Theme.palette.black.main,
    '&.category': {
      textTransform: 'uppercase',
    },
    '& .MuiTypography-root': {
      fontWeight: 500,
    },
  },
  listItemEndButton: {
    width: 200,
    borderBottomLeftRadius: '30px !important',
    borderBottomRightRadius: '30px !important',
    borderTopLeftRadius: '30px !important',
    borderTopRightRadius: '30px !important',
    border: 'none !important',
    backgroundColor: `${Theme.palette.primary.main} !important`,
    color: `${Theme.palette.white.contrastText} !important`,
    '&:hover': {
      backgroundColor: `${Theme.palette.primary.light} !important`,
    },
    '& .MuiTypography-h2': {
      fontSize: '27 !important',
      lineHeight: '37px !important',
      color: 'inherit !important',
    },
  },
  subDrawerOverlay: {
    position: 'fixed',
    top: 0,
    left: MENU_DESKTOP_WIDTH,
    width: `calc(${MENU_DESKTOP_WIDTH}px + 20px)`,
    height: '100vh',
    paddingLeft: 20,
    boxSizing: 'border-box',
    backgroundColor: alpha(Theme.palette.secondary.main, 0.97),
    zIndex: 8,
    transform: 'translateX(-100%)',
    opacity: 0,
    pointerEvents: 'none',
    transition: 'transform 250ms ease, opacity 200ms ease',
    '&.open': {
      transform: 'translateX(0)',
      opacity: 1,
      pointerEvents: 'auto',
    },
  },
  subDrawerPaper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: Theme.spacing(4),
    paddingBottom: Theme.spacing(4),
    boxSizing: 'border-box',

    "& ::-webkit-scrollbar": {
      width: 8,
      height: 10,
    },
    "& ::-webkit-scrollbar-thumb": {
      background: Theme.palette.black.main,
      borderRadius: 5,
      height: '10px',
      border: '2px solid transparent',
    },
    scrollbarWidth: 'thin',
    scrollbarColor: `${Theme.palette.white.main} transparent`,
  },
  subDrawerHeader: {
    padding: `${Theme.spacing(2)} ${Theme.spacing(4)} ${Theme.spacing(3)}`,
    color: `${Theme.palette.white.main} !important`,
    fontSize: '12px !important',
    fontWeight: '700 !important',
    letterSpacing: '1px !important',
    textTransform: 'uppercase',
  },
  subDrawerContent: {
    flex: 1,
    overflowY: 'auto',
    padding: `${Theme.spacing(1)} ${Theme.spacing(2)} ${Theme.spacing(2)} ${Theme.spacing(2)}`,
    boxSizing: 'border-box',
  },
  subList: {
    overflow: 'auto',
  },
  subListItem: {
    '&::after': {
      content: '""',
      width: 10,
      height: '100%',
      position: 'absolute',
      right: 0,
      transition: 'background-color 250ms',
      pointerEvents: 'none',
    },
    color: Theme.palette.white.main,
    '& > .MuiListItemButton-root': {
      paddingLeft: Theme.spacing(6),
    }
  },
  socialList: {
    width: '100%', 
    '& img': {
      width: 25,
      height: 25
    }
  },
  socialListMobile: {
    width: '80%',
    margin: 'auto',
    marginTop: Theme.spacing(2),
    marginBottom: Theme.spacing(1),
    '& img': {
      width: 35,
      height: 35
    }
  },
  menuIconWrapper: {
    minWidth: '30px !important',
  },
  menuIcon: {
    width: 20,
    height: 20,
    objectFit: 'contain',
  },
  flagIcon: {
    width: 60,
    objectFit: 'contain',
  },
  sharePopper: {
    zIndex: 9,
    '& .MuiTypography-root': {
      color: Theme.palette.primary.ligth,
    },
  },
  logoLoader: {
    width: 100,
    objectFit: 'contain',
  },
  mobileMenuHeader: {
    height: MENU_MOBILE_HEADER_HEIGHT,
    padding: Theme.spacing(2, 4, 2),
    backgroundColor: Theme.palette.white.main,
    transition: 'top 250ms !important',

    '& img': {
      maxWidth: 200,
      height: 32,
      objectFit: 'contain',
    },

    '.fullscreen &': {
      top: `-${MENU_MOBILE_HEADER_HEIGHT}px`,
    },
  },
  mobileMenuFooter: {
    // display: 'none',
    width: '100%',
    height: MENU_MOBILE_FOOTER_HEIGHT,
    padding: Theme.spacing(1, 2, 0),
    boxSizing: 'border-box',
    position: 'fixed',
    bottom: -MENU_MOBILE_FOOTER_HEIGHT,
    backgroundColor: Theme.palette.white.main,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    transition: 'bottom 250ms !important',
    overflow: 'hidden',
    zIndex: 1300,
    
    '&.pageHasLink': {
      transition: 'bottom 250ms !important 250ms',
      bottom: 0,
    },

    '.fullscreen &': {
      bottom: `-${MENU_MOBILE_FOOTER_HEIGHT}px`,
    },
  },
  mobileMenuFooterContent: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mobileMenuButtonWrapper: {
    paddingBottom: Theme.spacing(2),
    position: 'relative',
    marginLeft: '0 !important',
    
    '& h2': { color: Theme.palette.secondary.main },

    '&::after': {
      content: '""',
      width: '100%',
      height: 10,
      position: 'absolute',
      left: 0,
      bottom: 0,
      transition: 'background-color 250ms',
      pointerEvents: 'none',
    },
  },
  mobileMenuFooterLink: {
    backgroundColor: Theme.palette.primary.main,
    color: Theme.palette.white.main,
    borderRadius: '50px',
    textDecoration: 'none',
    padding: `${Theme.spacing(1)} ${Theme.spacing(2)}`,
  },
  mobileMenuButton: {
    position: 'relative',
    bottom: 0,
    transition: 'background-color 250ms, bottom 250ms !important',
    width: '40px !important',
    textAlign: 'center',
    margin:'auto',
    minWidth: 'initial !important',
    
    '&.menuOpen': {
      bottom: Theme.spacing(1),
    },
  }, 
  mobileMenuSwipe: {
    overflow: 'hidden',
    maxHeight: '70vh',
    borderTopLeftRadius: '20px !important',
    borderTopRightRadius: '20px !important',
    
    '& .MuiTypography-h2': {
      paddingLeft: Theme.spacing(4),
      paddingRight: Theme.spacing(4),
      fontSize: 26,
      lineHeight: '32px',
    },
    '& .MuiTypography-h4': {
      fontSize: 12,
      lineHeight: '18px',
    },
  },
  mobileMenuSwipePaper: {
    maxHeight: '70vh',
    paddingTop: Theme.spacing(4),
    paddingBottom: `calc(${MENU_MOBILE_FOOTER_HEIGHT}px + 5px)`,
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  mobileMenuContent: {
    height: '100%',
    minHeight: 0,
    marginTop: `${Theme.spacing(2)} !important`,
    marginBottom: `${Theme.spacing(2)} !important`,
  },
  mobileMenuActions: {
    flexShrink: 0,
    padding: Theme.spacing(0, 3),
    boxSizing: 'border-box',
  },
  mobileMenuPuller: {
    width: 30,
    height: 6,
    backgroundColor: Theme.palette.white.dark,
    borderRadius: 3,
    position: 'absolute',
    top: 8,
    left: 'calc(50% - 15px)',
  },
  shareAndDownloadMobileButton: {
    paddingLeft: `12px !important`,
    '& .MuiTypography-root': {
      color: Theme.palette.black.main,
    },
    '& .MuiListItemIcon-root': {
      minWidth: '35px !important',
    },
  },
});

export default appMenu;
